module.exports = __webpack_public_path__ + "img/location.7d9efaee.png";